// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 1H20V5H18V3H6V17H20V23H4V1ZM13.0039 19H11V21.0039H13.0039V19Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.4551 14.506L21.8863 15.2869L21.1054 16.8557L20.3245 15.2869L18.7557 14.506L20.3245 13.7251L21.1054 12.1562L21.8863 13.7251L23.4551 14.506Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.9599 12.0966L16.057 14.3007L17.1541 12.0966L19.3581 10.9995L17.1541 9.90243L16.057 7.69839L14.9599 9.90243L12.7559 10.9995L14.9599 12.0966Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.4551 7.4962L21.8863 8.27709L21.1054 9.84589L20.3245 8.27709L18.7557 7.4962L20.3245 6.71529L21.1054 5.14648L21.8863 6.71529L23.4551 7.4962Z"}}]};

const MobileShortcutFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mobile-shortcut-filled',
    ref,
    icon: element,
  },
));

MobileShortcutFilledIcon.displayName = 'MobileShortcutFilledIcon';

export default MobileShortcutFilledIcon;
